import React, { PropsWithChildren } from 'react';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

type Props = PropsWithChildren<{
    title?: string;
}>;

const Message: React.FC<Props> = (props: Props) => {
    const { children, title } = props;

    return (
        <OverlayTrigger
            placement="left-start"
            trigger={['hover', 'focus']}
            delay={{ show: 250, hide: 400 }}
            overlay={
                <Popover id={`popover-positioned-left`} className="message">
                    <Popover.Title as="h3">{title || 'Let op!'}</Popover.Title>
                    <Popover.Content>{children}</Popover.Content>
                </Popover>
            }
        >
            <ExclamationTriangleFill className="message" />
        </OverlayTrigger>
    );
};

export default Message;
